import React from "react";
import { FunctionField } from "react-admin";
import { RequestType } from "../../Enums/RequestType";
import { formatDate } from "../../Helper/MomentHelper";
/**
 * @example
 * */

export const RDDDatetimeField = props => {
  return (
    <FunctionField
      label="Requested Delivery Date"
      render={(record: any) => {
        return record.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : formatDate(record.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
            ? "Exclude"
            : record.requestType === RequestType.RBH
              ? formatDate(record.requestedDeliveryDate, false)
              : formatDate(record.requestedDeliveryDate);
      }}
      {...props}
    />
  );
};

RDDDatetimeField.propTypes = {
  ...FunctionField.prototype,
};

RDDDatetimeField.defaultProps = {};

export default RDDDatetimeField;
